import {
  alertDetailsBoxClicked,
  alertDetailsMarkerComplete,
  alertDetailsToggleInfo,
  alertDetailsUpdateDetails,
  alertDetailsUpdateIncidentLocation,
  alertDetailsUpdateIPaws,
  alertDetailsUpdateRadio,
  alertDetailsUpdateSeverity,
  audienceListCheckBoxChanged,
  cancelAudienceGroups,
  chooseAudienceBoxClicked,
  chooseAudienceUpdateGeoMapList,
  chooseAudienceUpdateGeoMapShape,
  clearMap,
  composeAction,
  composeMessageMultiMediaClicked,
  composeMessageRecordAudio,
  composeMessageRemoveMultiMedia,
  composeMessageToggleInfo,
  composeMessageUpdateInput,
  composeMessageUpdateMultiMediaState,
  composeMessageUploadMultiMedia,
  copyData,
  launchCodeChanged,
  manageGroupList,
  previewSendToggleLaunch,
  retryCompose,
  saveAudienceGroups,
  scheduleAlert,
  selectChannelsBoxClicked,
  selectChannelsBoxListChanged,
  sendCompose,
  showComposeToolBars,
  updateGeoFence,
  updateStepper
} from "./alerts-compose-api";

export const onInitializeStepper = (history: any) => {
  return (dispatch: any, getState: any) => {
    const pathname = history.location.pathname;
    const pathArr = pathname.split("/");
    const potentialUrl =
      pathArr[pathArr.length - 2] === "compose"
        ? ""
        : pathArr[pathArr.length - 2] + "/";
    const nav = potentialUrl + pathArr[pathArr.length - 1];
    const composeData = getState().alerts.composeData;
    updateStepper({ dispatch, composeData, nav, history, init: true });
  };
};

export const onRetryCompose = () => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    retryCompose({ dispatch, composeData });
  };
};

export const onScheduleAlert = (scheduledDate: any, scheduledTime: any) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const data = alerts.composeData;
    const list = alerts.data.list;
    const tabId = alerts.tabId;
    scheduleAlert({
      dispatch,
      data,
      type: "scheduled",
      scheduledDate,
      scheduledTime,
      tabId,
      list
    });
  };
};

export const onSendCompose = () => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    sendCompose({ dispatch, composeData });
  };
};

export const onLaunchCodeChanged = (id: string, value: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    launchCodeChanged({ dispatch, id, value, composeData });
  };
};

export const onPreviewSendToggleLaunch = () => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    previewSendToggleLaunch({ dispatch, composeData });
  };
};

export const onUpdateStepper = (nav: string, history: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    updateStepper({ dispatch, composeData, nav, history });
  };
};

export const onComposeAction = (value: string) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const list = alerts.data.list;
    const data = alerts.composeData;
    const nodeData = alerts.nodeData;
    const tabId = alerts.tabId;
    composeAction({
      dispatch,
      value,
      list,
      type: "drafts",
      tabId,
      data,
      nodeData
    });
  };
};

export const onSelectChannelsBoxListChanged = (id: string, type: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    selectChannelsBoxListChanged({ dispatch, composeData, id, type });
  };
};

export const onSelectChannelsBoxClicked = (id: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    selectChannelsBoxClicked({ dispatch, composeData, id });
  };
};

export const onCopyData = (id: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    copyData({ dispatch, composeData, id });
  };
};

export const onChooseAudienceBoxClicked = (id: string, history: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    chooseAudienceBoxClicked({ dispatch, composeData, id, history });
  };
};

export const onUpdateGeoFence = (status: boolean, history: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    updateGeoFence({ dispatch, composeData, status, history });
  };
};

export const onSaveAudienceGroups = (list: any, history: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    saveAudienceGroups({ dispatch, composeData, history, list });
  };
};

export const onCancelAudienceGroups = (history: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    cancelAudienceGroups({ dispatch, composeData, history });
  };
};

export const onShowComposeBottomBar = (show: boolean) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    showComposeToolBars({
      dispatch,
      composeData,
      show
    });
  };
};

export const onAudienceListCheckBoxChanged = (id: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    audienceListCheckBoxChanged({ dispatch, composeData, id });
  };
};

export const onManageGroupList = (type: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    manageGroupList({ dispatch, composeData, type });
  };
};

export const onAlertDetailsUpdateSeverity = (type: string, id: number) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsUpdateSeverity({ dispatch, composeData, type, id });
  };
};

export const onAlertDetailsUpdateIPaws = (type: string, value: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsUpdateIPaws({ dispatch, composeData, type, value });
  };
};

export const onComposeMessageRemoveMultiMedia = (name: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    composeMessageRemoveMultiMedia({ dispatch, composeData, name });
  };
};

export const onAlertDetailsBoxClicked = (id: string, history: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsBoxClicked({ id, history, composeData, dispatch });
  };
};

export const onClearMap = (id: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    clearMap({ id, composeData, dispatch });
  };
};

export const onToggleMoreInfo = (type: string, screen: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    if (screen === "alert-details") {
      alertDetailsToggleInfo({ dispatch, composeData, type });
    }
    if (screen === "compose-message") {
      composeMessageToggleInfo({ dispatch, composeData, type });
    }
  };
};

export const onAlertDetailsMarkerComplete = (marker: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsMarkerComplete({ dispatch, composeData, marker });
  };
};

export const onAlertDetailsUpdateIncidentLocation = (
  status: boolean,
  path: string,
  history: any
) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsUpdateIncidentLocation({
      dispatch,
      composeData,
      status,
      path,
      history
    });
  };
};

export const onAlertDetailsUpdateRadio = (type: string, value: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsUpdateRadio({ dispatch, composeData, type, value });
  };
};

export const onAlertDetailsUpdateDetails = (type: string, value: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    alertDetailsUpdateDetails({ dispatch, composeData, type, value });
  };
};

export const onComposeMessageUpdateInput = (type: string, value: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    composeMessageUpdateInput({ dispatch, composeData, type, value });
  };
};

export const onComposeMessageMultiMediaClicked = (
  type: string,
  state: string
) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    composeMessageMultiMediaClicked({ dispatch, composeData, type, state });
  };
};

export const onComposeMessageUpdateMultiMediaState = (state: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    composeMessageUpdateMultiMediaState({ dispatch, composeData, state });
  };
};

export const onComposeMessageUploadMultiMedia = (files: any, id: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    composeMessageUploadMultiMedia({ dispatch, composeData, files, id });
  };
};

export const onComposeMessageRecordAudio = (type: string) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    composeMessageRecordAudio({ dispatch, composeData, type });
  };
};

export const onChooseAudienceUpdateGeoMapList = (listItem: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    chooseAudienceUpdateGeoMapList({ dispatch, composeData, listItem });
  };
};

export const onChooseAudienceUpdateGeoMapShape = (shape: any) => {
  return (dispatch: any, getState: any) => {
    const composeData = getState().alerts.composeData;
    chooseAudienceUpdateGeoMapShape({ dispatch, composeData, shape });
  };
};


// WEBPACK FOOTER //
// ./src/actions/alerts/alerts-compose.tsx